import { render, staticRenderFns } from "./ReopenOpenRequestModal.vue?vue&type=template&id=ef2526e2&scoped=true"
import script from "./ReopenOpenRequestModal.vue?vue&type=script&lang=js"
export * from "./ReopenOpenRequestModal.vue?vue&type=script&lang=js"
import style0 from "./ReopenOpenRequestModal.vue?vue&type=style&index=0&id=ef2526e2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2526e2",
  null
  
)

export default component.exports